"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _Wordmark = _interopRequireDefault(require("./logos/Wordmark"));
var _Condensed = _interopRequireDefault(require("./logos/Condensed"));
var _Pill = _interopRequireDefault(require("./logos/Pill"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Logo = function Logo(_ref) {
  var theme = _ref.theme,
    type = _ref.type,
    size = _ref.size,
    className = _ref.className,
    color = _ref.color,
    title = _ref.title;
  var fillColor = theme.colors[color] || theme.logo.color;
  var logoProps = {
    size: size,
    className: className,
    fillColor: fillColor,
    type: type,
    title: title
  };
  var logoTypes = {
    primary: /*#__PURE__*/_react.default.createElement(_Pill.default, logoProps),
    secondary: /*#__PURE__*/_react.default.createElement(_Wordmark.default, logoProps),
    tertiary: /*#__PURE__*/_react.default.createElement(_Condensed.default, logoProps)
  };
  return logoTypes[type];
};
Logo.defaultProps = {
  type: 'primary',
  size: 'sm'
};
var _default = (0, _styledComponents.withTheme)(Logo);
exports.default = _default;